// TODO: move to ../node/runtime/html/notSerializable.ts once code is distributed as ESM
export const notSerializable = 'not-serializable';
